import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/verification/registration.tsx";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import { logIn, verifyCredentials } from 'soapbox/actions/auth';
import { fetchInstance } from 'soapbox/actions/instance';
import { startOnboarding } from 'soapbox/actions/onboarding';
import snackbar from 'soapbox/actions/snackbar';
import { createAccount, removeStoredVerification } from 'soapbox/actions/verification';
import { Button, Form, FormGroup, Input, Text } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector, useSoapboxConfig } from 'soapbox/hooks';
import { getRedirectUrl } from 'soapbox/utils/redirect';
import PasswordIndicator from './components/password-indicator';
const messages = defineMessages({
  success: {
    "id": "registrations.success",
    "defaultMessage": "Welcome to {siteTitle}!"
  },
  usernameTaken: {
    "id": "registrations.unprocessable_entity",
    "defaultMessage": "This username has already been taken."
  },
  error: {
    "id": "registrations.error",
    "defaultMessage": "Failed to register your account."
  }
});
const initialState = {
  username: '',
  password: ''
};
const Registration = () => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const soapboxConfig = useSoapboxConfig();
  const {
    links
  } = soapboxConfig;
  const isLoading = useAppSelector(state => state.verification.isLoading);
  const siteTitle = useAppSelector(state => state.instance.title);
  const [state, setState] = React.useState(initialState);
  const [shouldRedirect, setShouldRedirect] = React.useState(false);
  const [hasValidPassword, setHasValidPassword] = React.useState(false);
  const {
    username,
    password
  } = state;
  const handleSubmit = React.useCallback(event => {
    event.preventDefault();
    dispatch(createAccount(username, password)).then(() => dispatch(logIn(username, password))).then(({
      access_token
    }) => dispatch(verifyCredentials(access_token))).then(() => dispatch(fetchInstance())).then(() => {
      setShouldRedirect(true);
      removeStoredVerification();
      dispatch(startOnboarding());
      dispatch(snackbar.success(intl.formatMessage(messages.success, {
        siteTitle
      })));
    }).catch(error => {
      if (error?.response?.status === 422) {
        dispatch(snackbar.error(intl.formatMessage(messages.usernameTaken)));
      } else {
        dispatch(snackbar.error(intl.formatMessage(messages.error)));
      }
    });
  }, [username, password]);
  const handleInputChange = React.useCallback(event => {
    event.persist();
    setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      [event.target.name]: event.target.value
    }));
  }, []);
  if (shouldRedirect) {
    const redirectUri = getRedirectUrl();
    return /*#__PURE__*/React.createElement(Redirect, {
      to: redirectUri,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-600 border-solid -mx-4 sm:-mx-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-center font-bold text-2xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.header",
    defaultMessage: "Register your account",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sm:pt-10 sm:w-2/3 md:w-1/2 mx-auto space-y-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    labelText: "Your username",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Input, {
    name: "username",
    type: "text",
    value: username,
    onChange: handleInputChange,
    required: true,
    icon: require('@tabler/icons/at.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(FormGroup, {
    labelText: "Password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Input, {
    name: "password",
    type: "password",
    value: password,
    onChange: handleInputChange,
    required: true,
    "data-testid": "password-input",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(PasswordIndicator, {
    password: password,
    onChange: setHasValidPassword,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center space-y-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    theme: "primary",
    type: "submit",
    disabled: isLoading || !hasValidPassword,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 13
    }
  }, "Register"), links.get('termsOfService') && links.get('privacyPolicy') ? /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "xs",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.acceptance",
    defaultMessage: "By registering, you agree to the {terms} and {privacy}.",
    values: {
      terms: /*#__PURE__*/React.createElement("a", {
        href: links.get('termsOfService'),
        target: "_blank",
        className: "text-primary-600 dark:text-primary-400 hover:underline",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 148,
          columnNumber: 23
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "registration.tos",
        defaultMessage: "Terms of Service",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 149,
          columnNumber: 25
        }
      })),
      privacy: /*#__PURE__*/React.createElement("a", {
        href: links.get('privacyPolicy'),
        target: "_blank",
        className: "text-primary-600 dark:text-primary-400 hover:underline",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156,
          columnNumber: 23
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "registration.privacy",
        defaultMessage: "Privacy Policy",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157,
          columnNumber: 25
        }
      }))
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 143,
      columnNumber: 17
    }
  })) : null))));
};
export default Registration;